package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.repository.FinancialRepository

class CloseDayUseCase(
    private val financialRepository: FinancialRepository
) {
    suspend operator fun invoke(dailyRecordId: String): Result<Unit> {
        return try {
            // 1. Sprawdź, czy utarg został wpisany
            val dailyRecord = financialRepository.getDailyRecord(dailyRecordId).getOrThrow()
            if (dailyRecord.revenue.realNetto == null) {
                throw IllegalStateException("Cannot close day without submitting revenue first.")
            }

            // 2. Pobierz zmiany z tego dnia i sprawdź, czy nie ma otwartych konfliktów
            // (Logika opcjonalna, zależy od rygoru firmy)

            // 3. Zablokuj dzień (ustaw flagę isLocked w DailyRecord)
            // Wymaga dodania pola isLocked do modelu DailyRecord
            financialRepository.lockDailyRecord(dailyRecordId).getOrThrow()

            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}